import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AutomobileService } from '../shared/automobile.service';

@Component({
  selector: 'app-dealer',
  templateUrl: './dealer.component.html',
  styleUrls: ['./dealer.component.css']
})
export class DealerComponent implements OnInit {
  handle: any;

  constructor( private routeParam: ActivatedRoute){}
  
  ngOnInit(): void {
    this.routeParam.params.subscribe(params=>{
      this.handle = params['handle'];
      
    })
  }

}
